import { PageFooter } from './styles';

export const Footer = () => {
  return (
    <PageFooter id="site-footer">
      SANA TERAPIA MANUAL
    </PageFooter>
  );
};

export default Footer;
